/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Sale_PurchaseInputs */

const cs_enum_sale_purchase = /** @type {(inputs: Enum_Sale_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupní smlouva`)
};

const en_enum_sale_purchase = /** @type {(inputs: Enum_Sale_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale purchase`)
};

/**
* | output |
* | --- |
* | "Sale purchase" |
*
* @param {Enum_Sale_PurchaseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sale_purchase = /** @type {((inputs?: Enum_Sale_PurchaseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Sale_PurchaseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sale_purchase(inputs)
	return cs_enum_sale_purchase(inputs)
});